module.exports = __webpack_public_path__ + "static/media/02.7e7ba23e.jpg";